import React from 'react';
import type RoadmapViewClassicType from '@jira/spa-apps__roadmap/src/RoadmapViewClassicType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

/** @deprecated Use entrypoint roadmapViewClassicPageEntrypoint */
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyRoadmapViewClassic: LazyComponent<(props: any) => React.JSX.Element> =
	lazyForPaint<typeof RoadmapViewClassicType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-classic-roadmap", jiraSpaEntry: "async-classic-roadmap" */ '@jira/spa-apps__roadmap/src/RoadmapViewClassicType.tsx'
			),
		),
	);

/** @deprecated Use entrypoint roadmapViewClassicPageEntrypoint */

const AsyncRoadmapViewClassic = ({ match }: RouteContext): React.JSX.Element => {
	const { boardId } = match.params;
	return (
		<LazyPage
			Page={LazyRoadmapViewClassic}
			pageId={`classic-roadmap-${boardId || ''}`}
			shouldShowSpinner={false}
		/>
	);
};

export default AsyncRoadmapViewClassic;
